import { BASE_MEDIA_URL } from "@/constants/api";

export function isYouTubeUrl(url: string): boolean {
  if (!url) return false;
  const pattern =
    /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be|youtube-nocookie\.com)\/.+$/i;
  return pattern.test(url.trim());
}

export const getMediaUrl = (path?: unknown): string => {
  if (typeof path !== 'string' || !path.trim()) return '';
  const cleanPath = path.trim();
  if (cleanPath.startsWith('http://') || cleanPath.startsWith('https://')) {
    return cleanPath;
  }
  const cleanBase = BASE_MEDIA_URL.replace(/\/+$/, '');
  const cleanSub = cleanPath.replace(/^\/+/, '');
  return `${cleanBase}/${cleanSub}`;
};

export const stripHtml = (html?: string): string => {
  if (!html) return '';
  return html.replace(/<[^>]*>?/gm, '').trim();
};

export const getCourseTitle = (course?: any): string => {
  if (!course) return '';
  if (typeof course === 'string') return course;

  // Direct title or name
  if (typeof course.title === 'string' && course.title.trim()) return course.title.trim();
  if (typeof course.name === 'string' && course.name.trim()) return course.name.trim();

  // Nested translations array
  if (Array.isArray(course.translations) && course.translations.length > 0) {
    for (const locale of ['uz', 'ru', 'en']) {
      const trans = course.translations.find((t: any) => t?.locale === locale);
      const text = trans?.title || trans?.name || trans?.subtitle;
      if (text && typeof text === 'string' && text.trim()) return text.trim();
    }
    for (const t of course.translations) {
      const text = t?.title || t?.name || t?.subtitle;
      if (text && typeof text === 'string' && text.trim()) return text.trim();
    }
  }

  // Nested translations object
  if (course.translations && typeof course.translations === 'object') {
    const uz = course.translations.uz;
    const uzText = uz?.title || uz?.name || uz?.subtitle;
    if (uzText && typeof uzText === 'string' && uzText.trim()) return uzText.trim();

    for (const val of Object.values(course.translations)) {
      const v: any = val;
      const text = v?.title || v?.name || v?.subtitle;
      if (text && typeof text === 'string' && text.trim()) return text.trim();
    }
  }

  // Alternative field names
  if (typeof course.courseName === 'string' && course.courseName.trim()) return course.courseName.trim();
  if (typeof course.courseTitle === 'string' && course.courseTitle.trim()) return course.courseTitle.trim();

  return '';
};

export const getCourseImage = (course?: any): string => {
  if (!course) return '';
  const img = course.photo || course.icon || course.cardImage || course.bannerImage || course.decorImage || '';
  return img ? getMediaUrl(img) : '';
};
